import { useMemo } from "react";
import useProductosPrecargadosN2 from "./useProductosPrecargadosN2";

/**
 * Hook que precarga los productos de cada pedido suelto de un listado de Nave 2, para
 * imprimir su etiqueta (y la de altura / Tronja 3, si toca) sin esperar.
 *
 * DECISION: una petición por pedido al abrir, cacheada por ejercicio + pedido. El
 * listado se refresca cada 30 s con objetos nuevos, pero un pedido solo se recarga si
 * cambia su clave. Cada pedido se trata como un grupo de uno, y esa conversión se
 * memoiza para no relanzar el efecto en cada render.
 *
 * @param {Array} pedidos - Filas del listado (num, type)
 * @returns {Object<string, Array|null|undefined>} Productos por `num` de pedido:
 *   `undefined` mientras carga, `null` si la carga falló
 */
const useProductosPedidosN2 = (pedidos) => {
    const gruposDeUno = useMemo(
        () => pedidos.map((pedido) => ({ id: pedido.num, pedidos: [{ numero: pedido.num, tipo: pedido.type }] })),
        [pedidos]
    );

    return useProductosPrecargadosN2(gruposDeUno, 'pedido');
};

export default useProductosPedidosN2;
